import { render, staticRenderFns } from "./RequestContact.vue?vue&type=template&id=af07c396&"
import script from "./RequestContact.vue?vue&type=script&lang=js&"
export * from "./RequestContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports